import { Dictionary } from '@app/types';

export interface State {
   viewState: Dictionary<any>;
}

export const initialState: State = {
   viewState: {}
};
